import { ROLE } from '../../consts'

export const isProfileCompleteAllowed = user => {
  if (user?.role === ROLE.STUDENT) {
    return user?.student_profile?.filled
  }
  return true
}
